<template>
  <div class="cs-studentProfile-main">
    <el-row>
      <el-col :span="7" class="cs-studentProfile-left">
        <el-row class="cs-studentProfile-item">
        <studentInfo :data="this.data" @loaded="onStudentInfoLoaded"></studentInfo>
        </el-row>
        <el-row class="cs-studentProfile-item">
        <studentCourseHistory :data="this.data" @loaded="onStudentCourseHistoryLoaded"></studentCourseHistory>
        </el-row>
      </el-col>
      <el-col :span="17" class="cs-studentProfile-right">
        <el-row class="cs-studentProfile-item">
        <studentCourseSigninInfo :data="this.data" @loaded="onStudentCourseSigninInfoLoaded"></studentCourseSigninInfo>
        </el-row>
        <el-row class="cs-studentProfile-item">
        <specificStudentHomeworkList
          :data="this.data"
          @loaded="onSpecificStudentHomeworkListLoaded"
        ></specificStudentHomeworkList>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
.cs-studentProfile-main{
  padding: 40px;
}
.cs-studentProfile-left{
  padding-right: 40px;
}
.cs-studentProfile-item{
  margin-bottom: 20px;
}
</style>

<script>
import studentInfo from "./studentInfo";
import studentCourseSigninInfo from "./studentCourseSigninInfo";
import studentCourseHistory from "./studentCourseHistory";
import specificStudentHomeworkList from "./specificStudentHomeworkList";

export default {
  props: {
    data: {
      studentId: Number,
      courseId: Number,
      campusId: Number,
      courseName: String
    }
  },
  data() {
    return {
      isLoading: false,
      studentInfoLoaded: false,
      studentCourseHistoryLoaded: false,
      studentCourseSigninInfoLoaded: false,
      specificStudentHomeworkListLoaded: false
    };
  },
  components: {
    studentInfo,
    studentCourseSigninInfo,
    studentCourseHistory,
    specificStudentHomeworkList
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.isLoading = true;
      this.studentInfoLoaded = false;
      this.studentCourseHistoryLoaded = false;
      this.studentCourseSigninInfoLoaded = false;
      this.specificStudentHomeworkListLoaded = false;
    },
    onStudentInfoLoaded() {
      this.studentInfoLoaded = true;
      this.handleDataLoaded();
    },
    onStudentCourseHistoryLoaded() {
      this.studentCourseHistoryLoaded = true;
      this.handleDataLoaded();
    },
    onStudentCourseSigninInfoLoaded() {
      this.studentCourseSigninInfoLoaded = true;
      this.handleDataLoaded();
    },
    onSpecificStudentHomeworkListLoaded() {
      this.specificStudentHomeworkListLoaded = true;
      this.handleDataLoaded();
    },
    handleDataLoaded() {
      if (
        this.studentInfoLoaded &&
        this.studentCourseHistoryLoaded &&
        this.studentCourseSigninInfoLoaded &&
        this.specificStudentHomeworkListLoaded
      ) {
        this.isLoading = false;
      }
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/studentProfile.vue